import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getFunctions } from 'firebase/functions';

const firebaseConfig = {
    apiKey: "AIzaSyBp_9kkvlInc9Orxr4JbfkAN4ta10jsfEM",
    authDomain: "ai-shopify-image-gen.firebaseapp.com",
    projectId: "ai-shopify-image-gen",
    storageBucket: "ai-shopify-image-gen.firebasestorage.app",
    messagingSenderId: "380425785509",
    appId: "1:380425785509:web:a48c4f13710ba989ecfd4c"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const functions = getFunctions(app);

export default app;
